export const decimalPriceFormat = (value) => {
    let val = value.toString().replace(/\s/g, '')
    let newValue = val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");

    return newValue;
};
